import React, { Suspense, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import guias from "./registry";
import { Cargando, useGuia } from "./Guia";
import { BotonPlay } from "../periodico/Reproductor";
import { Vacio } from "../periodico/piezas";
import { IDIOMA, de, tr } from "../i18n/idioma";

/* Sección /guias (desde 2026-10-31, sustituye a /estudios). Landing con las tarjetas del
   registro y página de cada guía: carga su dataset vivo y se lo pasa al renderer congelado. */

const BASE = process.env.PUBLIC_URL || "";
const CSS = `
.gg-hero{display:grid; grid-template-columns:minmax(0,1.35fr) minmax(0,1fr); gap:40px; align-items:center; padding:40px 0 34px; border-bottom:1px solid var(--y-rule);}
.gg-hero h1{margin:12px 0 0;}
.gg-hero .y-lede{margin-top:14px; max-width:640px;}
.gg-trae{padding:18px 20px; background:var(--y-gui-bg); border-radius:20px; display:grid; gap:12px;}
.gg-trae ol{list-style:none; margin:0; padding:0; display:grid; gap:12px;}
.gg-trae li{display:grid; grid-template-columns:30px 1fr; gap:12px; align-items:start; font-size:14.5px; line-height:1.45; color:var(--y-gui-head);}
.gg-trae li b{display:block; font-weight:700;}
.gg-trae li > span:first-child{width:30px; height:30px; border-radius:50%; display:grid; place-items:center; background:var(--y-gui-head); color:#fff; font:700 12px var(--y-mono);}
.gg-trae > p{margin:0; font:600 10.5px var(--y-mono); letter-spacing:.12em; text-transform:uppercase; color:var(--y-gui-ink);}
.gg-lista{display:flex; flex-direction:column; gap:28px; margin-top:34px;}
.gg-guia{display:grid; grid-template-columns:minmax(0,1.15fr) minmax(0,1fr); gap:0; background:var(--y-surface); border-radius:26px; overflow:hidden;
  box-shadow:var(--y-shadow); color:inherit; text-decoration:none; transition:transform .25s cubic-bezier(.16,1,.3,1), box-shadow .25s;}
.gg-guia:hover{transform:translateY(-3px); box-shadow:0 18px 40px -22px rgba(25,43,80,.45);}
.gg-guia:nth-child(even) .gg-fig{order:2;}
.gg-fig{position:relative; margin:0; background:#efe9df; min-height:280px; overflow:hidden;}
.gg-fig img{position:absolute; inset:0; width:100%; height:100%; object-fit:cover; transition:transform .6s cubic-bezier(.16,1,.3,1);}
.gg-guia:hover .gg-fig img{transform:scale(1.03);}
.gg-fig--red{background:#e2e5df;}
.gg-num{position:absolute; left:18px; top:12px; font:800 64px/1 var(--y-font); letter-spacing:-.05em; color:var(--y-gui-head); opacity:.9; mix-blend-mode:multiply;}
.gg-txt{padding:30px 32px; display:flex; flex-direction:column; gap:12px;}
.gg-txt h2{margin:0; font:800 clamp(24px,2.6vw,32px)/1.12 var(--y-font); letter-spacing:-.02em; color:var(--y-ink);}
.gg-txt p.sub{margin:0; font-size:16px; line-height:1.55; color:var(--y-ink-2);}
.gg-chips{display:flex; flex-wrap:wrap; gap:6px; margin-top:4px;}
.gg-ir{margin-top:auto; padding-top:8px; font:700 15px var(--y-font); color:var(--y-gui-head);}
.gg-ir span{display:inline-block; transition:transform .25s;}
.gg-guia:hover .gg-ir span{transform:translateX(4px);}
.gg-metodo{margin-top:46px; padding-top:28px; border-top:1px solid var(--y-rule); display:grid; grid-template-columns:repeat(3,1fr); gap:22px;}
.gg-metodo h3{margin:6px 0 6px; font:700 17px var(--y-font);}
.gg-metodo p{margin:0; font-size:14.5px; line-height:1.55; color:var(--y-ink-2);}
@media (max-width:900px){
  .gg-hero{grid-template-columns:1fr; gap:22px; align-items:start;}
  .gg-guia{grid-template-columns:1fr;}
  .gg-guia:nth-child(even) .gg-fig{order:0;}
  .gg-fig{min-height:0; aspect-ratio:4/3;}
  .gg-txt{padding:22px 20px 24px;}
  .gg-metodo{grid-template-columns:1fr;}
}
`;

export function TarjetaGuia({ g, rotulo }) {
  return (
    <Link to={`/guias/${g.slug}`} className="y-card y-card--gui">
      <p className="y-eyebrow">{rotulo || `${tr("Guía práctica", "Practical guide")} · ${de(g, "etiqueta")}`}</p>
      <h3 className="y-card-t">{de(g, "titulo")}</h3>
      <p className="y-card-p" style={{ color: "var(--y-gui-head)" }}>{de(g, "subtitulo")}</p>
      <p style={{ margin: "14px 0 0", fontWeight: 600, fontSize: 14, color: "var(--y-gui-head)" }}>{tr("Abrir la guía →", "Open the guide →")}</p>
    </Link>
  );
}

export const guiasOrdenadas = [...guias].sort((a, b) => b.numero - a.numero);

export default function Guias() {
  const trae = [
    [tr("Una maqueta en 3D", "A 3D model"), tr("En las de energía, cada paso se monta como una película; luego la giras, aíslas piezas y miras por dentro.", "In the energy guides each step builds like a film; then you turn it, isolate parts and look inside.")],
    [tr("Cada cifra con su fuente", "A source for every figure"), tr("Y con su grado de confianza: lo que no está comprobado se dice.", "With its confidence level: what isn't verified is labelled as such.")],
    [tr("Un resumen en audio", "An audio summary"), tr("Para escucharlo mientras trabajas. Voz sintética, declarada.", "To listen to while you work. Synthetic voice, declared.")],
    [tr("Revisión de alguien con oficio", "Review by someone with the trade"), tr("Hasta entonces, la guía lleva el aviso «borrador».", "Until then, the guide carries a “draft” notice.")],
  ];
  return (
    <div className="y-wrap">
      <style>{CSS}</style>
      <header className="gg-hero">
        <div>
          <p className="y-eyebrow" style={{ color: "var(--y-gui-ink)" }}>{tr("Guías prácticas", "Practical guides")} · {guias.length}</p>
          <h1 className="y-h1">{tr("Hazlo tú, con datos.", "Do it yourself, with data.")}</h1>
          <p className="y-lede">
            {tr("Guías paso a paso para resolver problemas reales de la vida en Cuba: la luz, el gas, comunicarse sin exponerse. Las de energía se descargan para verlas sin internet y pasarlas por Zapya.",
              "Step-by-step guides to real problems of daily life in Cuba: power, cooking gas, communicating without exposing yourself. The energy guides can be downloaded to use offline and shared over Zapya.")}
          </p>
        </div>
        <div className="gg-trae">
          <p>{tr("Cada guía trae", "Each guide includes")}</p>
          <ol>{trae.map(([t, x], i) => <li key={t}><span aria-hidden="true">{i + 1}</span><span><b>{t}</b>{x}</span></li>)}</ol>
        </div>
      </header>

      <div className="gg-lista">
        {[...guias].sort((a, b) => a.numero - b.numero).map((g) => (
          <Link key={g.id} to={`/guias/${g.slug}`} className="gg-guia">
            <figure className={`gg-fig${g.offline ? "" : " gg-fig--red"}`}>
              <img src={`${BASE}/assets/guias/${g.slug}.webp`} alt="" loading="lazy" decoding="async" />
              <span className="gg-num" aria-hidden="true">{String(g.numero).padStart(2, "0")}</span>
            </figure>
            <div className="gg-txt">
              <p className="y-eyebrow" style={{ color: "var(--y-gui-ink)" }}>{tr("Guía", "Guide")} {String(g.numero).padStart(2, "0")} · {de(g, "etiqueta")}</p>
              <h2>{de(g, "titulo")}</h2>
              <p className="sub">{de(g, "subtitulo")}</p>
              <div className="gg-chips">
                <span className="y-badge y-badge--gui">{tr("Maqueta 3D", "3D model")}</span>
                <span className="y-badge y-badge--neutro">{tr("Resumen en audio", "Audio summary")}</span>
                <span className="y-badge y-badge--neutro">{g.offline ? tr("Se descarga sin internet", "Works offline") : tr("Solo web: no se descarga", "Web only: no download")}</span>
              </div>
              <p className="gg-ir">{tr("Abrir la guía", "Open the guide")} <span aria-hidden="true">→</span></p>
            </div>
          </Link>
        ))}
      </div>

      <section className="gg-metodo" aria-label={tr("Cómo se hace una guía", "How a guide is made")}>
        <div><p className="y-eyebrow" style={{ color: "var(--y-gui-ink)" }}>01</p>
          <h3>{tr("Un modelo con las cuentas a la vista", "A model with the sums in view")}</h3>
          <p>{tr("La maqueta, las calculadoras y los paneles leen el mismo modelo, con números reales y una comprobación hecha a mano.", "The model, the calculators and the panels all read the same model, with real numbers and a check done by hand.")}</p></div>
        <div><p className="y-eyebrow" style={{ color: "var(--y-gui-ink)" }}>02</p>
          <h3>{tr("Fuentes, no opiniones", "Sources, not opinions")}</h3>
          <p>{tr("Manuales de fabricantes, normas y estudios publicados. Cuando una cifra sale de un solo estudio, se dice.", "Manufacturers' manuals, standards and published studies. When a figure comes from a single study, we say so.")}</p></div>
        <div><p className="y-eyebrow" style={{ color: "var(--y-gui-ink)" }}>03</p>
          <h3>{tr("Revisada por quien sabe", "Checked by people who know")}</h3>
          <p>{tr("Un electricista, un técnico en biogás: hasta que firman, la guía es un borrador y lo pone bien visible.", "An electrician, a biogas technician: until they sign off, the guide is a draft and says so clearly.")}</p></div>
      </section>
    </div>
  );
}

export function GuiaPagina() {
  const { slug } = useParams();
  const g = guias.find((x) => x.slug === slug);
  const Renderer = useMemo(() => (g ? React.lazy(g.load) : null), [g]);
  const estado = useGuia(slug);
  if (!g) return <div className="y-wrap" style={{ paddingTop: 32 }}><Vacio>{tr("Esa guía no existe.", "That guide does not exist.")} <Link to="/guias">{tr("Ver todas las guías", "See all guides")}</Link></Vacio></div>;
  if (!estado.datos) return <Cargando estado={estado} />;
  const offline = g.offline ? `${BASE}/descargas/guias/${g.slug}${IDIOMA === "en" ? ".en" : ""}.html` : null;
  return (
    <Suspense fallback={<Cargando estado={{}} />}>
      <Renderer datos={estado.datos} slug={g.slug} contexto="web" BotonPlay={BotonPlay} offline={offline} />
    </Suspense>
  );
}
